import { useQuery } from '@tanstack/react-query';
import { useAPI, CompetenceListViewRow, Evaluated, EvaluationMode, EvaluationModeType } from '@nexelem/api';
import { Joda } from '../../utils';

type Options = {
  id?: number;
  competenceCategoryId?: number;
  name?: string;
};

const isEvaluated = (mode: EvaluationMode): mode is Evaluated => mode.tpe === EvaluationModeType.Evaluated;

export type Competence = Omit<CompetenceListViewRow, 'evaluationMode'> & {
  evaluationMode: {
    tpe: EvaluationModeType;
    period?: string;
    days?: number;
  };
};

export const useCompetences = (options?: Options, enabled?: boolean) => {
  const api = useAPI();
  return useQuery({
    enabled,
    queryKey: ['competences'],
    queryFn: () =>
      api
        .postBackWorkersCompetencesListFilter({
          postBackWorkersCompetencesListFilterRequest: {
            data: {},
          },
        })
        .then((data) => data.result.data ?? [])
        .then((data) =>
          data.map(({ evaluationMode, ...competence }) => {
            if (isEvaluated(evaluationMode)) {
              return {
                ...competence,
                evaluationMode: {
                  ...evaluationMode,
                  days: evaluationMode.period ? Joda.parsePeriodToDays(evaluationMode.period) : undefined,
                },
              } as Competence;
            }
            return {
              ...competence,
              evaluationMode,
            } as Competence;
          }),
        ),
    select: (data) =>
      data
        .filter(({ id }) => (options?.id ? id === options?.id : true))
        .filter(({ name }) => (options?.name ? name === options?.name : true))
        .filter(({ competenceCategoryId }) =>
          options?.competenceCategoryId ? competenceCategoryId === options?.competenceCategoryId : true,
        ),
  });
};
